import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "heading text-primary-black" }

import { ComputedRef, computed } from 'vue'

  // Components
  import Card from '@/components/UI/Card.vue'
  import TravellersList from './TravellersList.vue'
  import EditTravellersButton from './EditTravellersButton.vue'
  import TravellerModifyMessage from './TravellerModifyMessage.vue'
  import TravellersPanel from './TravellersPanel.vue'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Composables
  import { useBookingStatus } from '@/composables/useBookingStatus'
  import { isBookingNotYetInIresa } from '@/utils/bookingIresa'

  // CSE
  import CSEService from '@/services/CSEService'

  // Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  interface Props {
    booking: BookingSummary | null
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TravellersSection',
  props: {
    booking: {}
  },
  setup(__props: any) {

  // Vue
  const store = useStore()

  // Translations
  const { t } = useI18n()

  // Props
  const props = __props

  // Computed
  const { isReservationStatus } = useBookingStatus(props.booking)

  // UK locale check
  const isUK = computed<boolean>(() => {
    return store.getters.getLocale === 'en-GB'
  })

  const isReferenceEqualToBO = computed<boolean>(() =>
    isBookingNotYetInIresa(props.booking)
  )

  // Determine what to show based on conditions
  const shouldShowEditOptions = computed<boolean>(() => {
    const cseService = new CSEService()
    // For CSE companies, don't show anything
    if (cseService.isCgosOrCGOSPM) {
      return false
    } else {
      // For all other cases, show either button or message
      return true
    }
  })

  // Determine which component to show
  const editComponent = computed<string>(() => {
    if (!isReservationStatus.value || !shouldShowEditOptions.value) {
      return 'none'
    } else if (isUK.value) {
      return 'message'
    } else {
      return 'button'
    }
  })

  // Conditional container classes - only add justify-content-between and gap when there's a button
  const containerClasses = computed<string>(() => {
    return editComponent.value === 'button' ? 'justify-content-between gap-2' : 'gap-1'
  })

return (_ctx: any,_cache: any) => {
  return (_ctx.booking)
    ? (_openBlock(), _createBlock(Card, {
        key: 0,
        "additional-classes": "px-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["p-3 d-flex flex-column h-100", containerClasses.value])
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('travellers.title')), 1),
              _createVNode(TravellersList, {
                travellers: _ctx.booking.travellers,
                "departure-date": _ctx.booking.departureDate
              }, null, 8, ["travellers", "departure-date"])
            ]),
            (editComponent.value === 'button' && !isReferenceEqualToBO.value)
              ? (_openBlock(), _createBlock(EditTravellersButton, { key: 0 }))
              : (editComponent.value === 'message')
                ? (_openBlock(), _createBlock(TravellerModifyMessage, { key: 1 }))
                : _createCommentVNode("", true)
          ], 2),
          _createVNode(TravellersPanel)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})